import { useEffect, useMemo } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { fetchSimilarMerchantsById } from 'core/actions/ocapi';

import {
  selectRelatedStoresConfig,
  makeSelectRelatedStoresMerchants,
  makeSelectRelatedStoresIsLoading,
  makeSelectRelatedStoresIsLoaded,
  selectAllRelatedStoresMerchants,
  selectAllMerchantsAreLoaded,
} from '../selectors';

export const useGetRelatedStores = (merchantIds = []) => {
  const dispatch = useDispatch();

  const selectRelatedStoresMerchants = useMemo(makeSelectRelatedStoresMerchants, []);
  const selectRelatedStoresIsLoading = useMemo(makeSelectRelatedStoresIsLoading, []);
  const selectRelatedStoresIsLoaded = useMemo(makeSelectRelatedStoresIsLoaded, []);
  const config = useSelector(selectRelatedStoresConfig);

  const allMerchantsAreLoaded = useSelector(selectAllMerchantsAreLoaded);

  const allRelatedStoresMerchants = useSelector(selectAllRelatedStoresMerchants);

  const relatedMerchants = useSelector(state => (
    merchantIds.reduce((result, id) => {
      result[id] = {
        isLoading: selectRelatedStoresIsLoading(state, id),
        isLoaded: selectRelatedStoresIsLoaded(state, id),
        merchants: selectRelatedStoresMerchants(state, id),
      };
      return result;
    }, {})
  ));

  useEffect(() => {
    const { api: { params, options } } = config;
    Object.entries(relatedMerchants).forEach(([key, value]) => {
      const { isLoading, isLoaded } = value;
      if (!isLoading && !isLoaded) {
        dispatch(fetchSimilarMerchantsById(key, params, { ...options, namespace: key }));
      }
    });
  }, [merchantIds.length]);

  return {
    allRelatedStoresMerchants,
    allMerchantsAreLoaded,
  };
};
